<template>
    <modal :title="title" ref="modal">
        <q-tabs
                v-model="tab"
                dense
                class="text-grey-8"
                active-color="primary"
                indicator-color="primary"
                align="justify"
                narrow-indicator
        >
            <q-tab name="assigned" label="Assigned" />
            <q-tab name="unassigned" label="Unassigned" />
        </q-tabs>

        <q-separator />

        <q-tab-panels v-model="tab" animated>
            <q-tab-panel name="assigned">
                <assigned-clients :user="user" />
            </q-tab-panel>
            <q-tab-panel name="unassigned">
                <unassigned-clients :user="user" />
            </q-tab-panel>
        </q-tab-panels>
    </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { User } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AssignedClients from './AssignedClients.vue';
import UnassignedClients from './UnassignedClients.vue';

interface Data {
  tab: string,
}

export default defineComponent({
  mixins: [ModalMixin],
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  data(): Data {
    return {
      tab: 'assigned',
    };
  },
  computed: {
    title(): string {
      return `${this.user.firstName} ${this.user.lastName}`;
    },
  },
  components: {
    modal: Modal,
    AssignedClients,
    UnassignedClients,
  },
});
</script>
